<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                afflictionForm: () => import('../forms/AfflictionForm'),
                contactForm: () => import('../forms/ContactForm'),
                inspectionForm: () => import('../forms/InspectionForm'),
                memberForm: () => import('../forms/MemberForm'),
                biosecurityIncidentFileForm: () => import('../forms/BiosecurityIncidentFileForm'),
                fields: [
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [], form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'coordinates', text: 'Coordinates', value: 'coordinates', rules: [v => !!v || 'Coordinates is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Pest/Disease', value: 'afflictionId', rules: [v => !!v || 'Pest/Disease is required'], isRequired: true, form: () => import('./AfflictionForm'), apiMethod: 'Afflictions', claim: 'Afflictions' },
                    { type: 'autocomplete', text: 'Inspection', value: 'inspectionId', rules: [], form: () => import('./InspectionForm'), apiMethod: 'Inspections', claim: 'Inspections' },
                    { type: 'textarea', text: 'Comments', value: 'comments', rules: [v => !!v || 'Comments is required'], isRequired: true, maxLength: false },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'biosecurityIncidentId', form: () => import('../forms/BiosecurityIncidentFileForm') }
                ],
                apiMethod: 'BiosecurityIncidents',
                formTitle: 'Biosecurity Incident',
            }
        },
    };
</script>
